import { render, staticRenderFns } from "./UserDeactivated.vue?vue&type=template&id=28b22dda&scoped=true"
import script from "./UserDeactivated.vue?vue&type=script&lang=js"
export * from "./UserDeactivated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b22dda",
  null
  
)

export default component.exports